export const stepsStatus = {
  loading: 'loading',
  success: 'success',
  error: 'error',
};
